import React from 'react'

const HolidayHomePage = () => (
	<div>This is holiday homepage</div>
)

export default HolidayHomePage
